export const notificationsLocalization = {
	// Filter dropdown options
	'inbox.filters.dropdownOptions.unread': 'Non lette',
	'inbox.filters.dropdownOptions.default': 'Tutte le notifiche',
	'inbox.filters.dropdownOptions.archived': 'Archiviate',

	// Filter labels
	'inbox.filters.labels.unread': 'Non lette',
	'inbox.filters.labels.default': 'Tutte le notifiche',
	'inbox.filters.labels.archived': 'Archiviate',

	// Notifications section
	'notifications.emptyNotice': 'Nessuna news per ora. Controlla più tardi.',
	'notifications.actions.readAll': 'Segna tutte come lette',
	'notifications.actions.archiveAll': 'Elimina tutte',
	'notifications.actions.archiveRead': 'Elimina lette',
	'notifications.newNotifications': ({ notificationCount }: { notificationCount: number }) => {
		const MAX_NOTIFICATIONS_COUNT = 99;
		const notificationCountToDislpay = notificationCount > MAX_NOTIFICATIONS_COUNT ? `${MAX_NOTIFICATIONS_COUNT}+` : notificationCount;
		const ending = notificationCount === 1 ? 'nuova notifica' : 'nuove notifiche';
		return `${notificationCountToDislpay} ${ending}`;
	},

	// Individual notification actions
	'notification.actions.read.tooltip': 'Segna come letta',
	'notification.actions.unread.tooltip': 'Letta',
	'notification.actions.archive.tooltip': 'Elimina',
	'notification.actions.unarchive.tooltip': 'Disarchivia',

	// Preferences section
	'preferences.title': 'Preferenze',
	'preferences.emptyNotice': 'No notification specific preferences yet.',
	'preferences.global': 'Preferenze Globali',
	'preferences.workflow.disabled.notice':
		"Contatta l'amministratore per abilitare le gestione della sottoscrizione a questa notifica critica.",
	'preferences.workflow.disabled.tooltip': "Contatta l'amministratore per modificare",

	// Set locale
	locale: 'it-IT',

	// Dynamic localization for workflow names
	dynamic: {
		// use the workflowId as a key to localize the workflow name
		'comment-on-post': 'Pubblica commento',
	},
} as const;
